import React from 'react';
import { withStyles } from 'material-ui/styles';
import { ListItemText, ListSubheader, ListItemSecondaryAction } from 'material-ui/List';
import { MenuList, MenuItem } from 'material-ui/Menu';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Icon from 'material-ui/Icon';

const Component = React.Component;

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: '360px',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: '300px',
  }
});

class SelectableList extends Component {
  handleSelect = clickedItem => event => {
    const { onSelectionChange, name } = this.props;
    if (onSelectionChange)
    {
      let target;

      if (event.target)
      {
        target = event.target;
      }

      const selectedItems = Array.isArray(this.props.selectedItems) ? [...this.props.selectedItems] : [];
      const currentIndex = selectedItems.indexOf(clickedItem);

      if (currentIndex === -1)
      {
        selectedItems.push(clickedItem);
      }
      else
      {
        selectedItems.splice(currentIndex, 1);
      }

      event.persist();
      event.target = {...target, selectedItems, name};

      onSelectionChange(event);
    }
  }

  handleSecondaryActionClick = clickedItemValue => event => {
    const { onSecondaryActionClick } = this.props;
    if (onSecondaryActionClick)
    {
      let target;
      if (event.target)
      {
        target = event.target;
      }

      event.persist();
      event.target = {...target, clickedItemValue};

      onSecondaryActionClick(event);
    }
  }

  render() {
    return (
      <MenuList dense={this.props.dense} className={this.props.classes.root} subheader={<ListSubheader>{this.props.subHeader}</ListSubheader>}>
        {this.props.items.map(item =>
          <MenuItem component="div" key={item.id} onClick={this.handleSelect(item.id)} selected={this.props.selectedItems.includes(item.id)}>
            <Checkbox checked={this.props.selectedItems.includes(item.id)} tabIndex={-1} disableRipple />
            <ListItemText primary={item.primary} secondary={item.secondary} />
            <ListItemSecondaryAction>
                <IconButton onClick={this.handleSecondaryActionClick(item.id)}>
                  <Icon>info_outline</Icon>
                </IconButton>
              </ListItemSecondaryAction>
          </MenuItem>
        )}
      </MenuList>
    );
  }
}

export default withStyles(styles)(SelectableList);



// WEBPACK FOOTER //
// ./src/SelectableList.jsx